<template>
  <div>
    <template v-if="showType == 'panel'">
      <vk-offcanvas-content>
        <vk-offcanvas overlay :show.sync="edit">
          <vk-offcanvas-close @click="edit = false"></vk-offcanvas-close>
          <form method="post" action="javascript:void(0)" @submit="saveForm()">
            <vk-modal-title slot="header">{{ header }}</vk-modal-title>
            <div class="uk-margin" v-for="input in inputs">
              <label>{{ input }}</label>
              <input
                class="uk-input focus-input"
                v-model="form[input]"
                type="text"
              />
            </div>
            <div slot="footer" class="uk-text-right">
              <vk-button class="global-button" @click="edit = false"
                >İptal</vk-button
              >
              <button type="submit" class="primary-button">
                Kaydet
              </button>
            </div>
          </form>
        </vk-offcanvas>
      </vk-offcanvas-content>
    </template>
    <template v-else>
      <vk-modal :stuck="true" :show.sync="edit">
        <form method="post" action="javascript:void(0)" @submit="saveForm()">
          <vk-modal-close @click="show = false"></vk-modal-close>
          <vk-modal-title slot="header">{{ header }}</vk-modal-title>
          <div class="uk-margin" v-for="input in inputs">
            <label>{{ input }}</label>
            <input
              class="uk-input focus-input"
              v-model="form[input]"
              type="text"
            />
          </div>
          <div slot="footer" class="uk-text-right">
            <vk-button class="global-button" @click="edit = false"
              >İptal</vk-button
            >
            <button type="submit" class="primary-button">
              Kaydet
            </button>
          </div>
        </form>
      </vk-modal>
    </template>
    <vk-icon @click="edit = true" icon="plus"></vk-icon>
  </div>
</template>

<script>
import HttpService from "../../services/http";
export default {
  name: "inline-add",
  props: {
    header: String,
    inputs: Array | Object,
    table: String,
    showType: {
      default: "panel"
    }
  },
  data() {
    return {
      form: {},
      edit: false,
      type: "insert"
    };
  },
  created() {},
  methods: {
    saveForm() {
      HttpService.inlineSave({
        table: this.table,
        type: this.type,
        inputs: this.form
      }).then(resp => {
        if (resp.data.success) {
          this.edit = false;
          this.form = {};
          this.$emit("after", "success");
        }
      });
    }
  }
};
</script>

<style>
.flex {
  display: flex;
}
.flex .sm-btn {
  font-size: 10px;
  padding: 0px 10px;
  margin: 0px;
}
</style>
